
// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {getStore} from '../../../../store-factory';
import {readFavorites} from './read-favorites';
import {updateFavorite} from '../../../../shared/repositories';

export const addFavorites = payload =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());
        const userId = getStore().getState().user.details.id;

        try {

            await updateFavorite(userId, payload);

            await readFavorites(userId)(dispatch);

        } catch (error) {

            await readFavorites(userId)(dispatch);
            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/components/favorites/action-creators/add-favorite.js